import { handleTrackingButtonOnClick } from "./index";

export default function WhiteButton({ text, onClick }: Props) {
  return (
    <>
      <button
        type="button"
        className="focus:outline-none inline-flex h-8 w-20 items-center justify-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        onClick={() => handleTrackingButtonOnClick(text, onClick)}
      >
        {text}
      </button>
    </>
  );
}

interface Props {
  text: string;
  onClick: () => void;
}
